/**
 * 前置条件引导
 * yuxin.zhang
 */

import React from 'react';
import Cookie from 'js-cookie';
import { observer, inject } from 'mobx-react';
import { DialogOneBtn } from '@ok/Dialog';
import { Icon } from '@ok/okd';

import Page from '../../constants/PageLink';
import RootContext from '../../container/RootContext';
import './GuideBox.less';

const GUIDE_KYC1 = 'kyc1';
const GUIDE_KYC2 = 'kyc2';
const GUIDE_EMAIL = 'email';
const GUIDE_STEP2 = 'step2';
const GUIDE_TRADE_PWD = 'tradePwd';

const GUIDE_FROM_WITHDRAW_CURRENCY = 'withdrawCurrency';
const GUIDE_FROM_RECHARGE_CURRENCY = 'rechargeCurrency';
const GUIDE_FROM_RECHARGE_CASH = 'rechargeCash';
const GUIDE_FROM_WITHDRAW_CASH = 'withdrawCash';
const GUIDE_FROM_API = 'api';

const GuideType = {
  [GUIDE_STEP2]: 1,
  [GUIDE_EMAIL]: 2,
  [GUIDE_TRADE_PWD]: 3,
  [GUIDE_KYC1]: 4,
  [GUIDE_KYC2]: 5,
};

const GuideFrom = {
  [GUIDE_FROM_RECHARGE_CURRENCY]: 1,
  [GUIDE_FROM_WITHDRAW_CURRENCY]: 2,
  [GUIDE_FROM_RECHARGE_CASH]: 3,
  [GUIDE_FROM_WITHDRAW_CASH]: 4,
  [GUIDE_FROM_API]: 5,
};

const fromContent = {
  [GuideFrom[GUIDE_FROM_API]]: {
    title: 'guide.for.api',
    next: 'guide.to.api',
    link: Page.myApi,
  },
  [GuideFrom[GUIDE_FROM_RECHARGE_CASH]]: {
    title: 'guide.for.rechargeCash',
    next: 'guide.to.rechargeCash',
    link: Page.usdDepositPage,
  },
  [GuideFrom[GUIDE_FROM_WITHDRAW_CASH]]: {
    title: 'guide.for.withdrawCash',
    next: 'guide.to.withdrawCash',
    link: Page.usdWithdrawPage,
  },
  [GuideFrom[GUIDE_FROM_RECHARGE_CURRENCY]]: {
    title: 'guide.for.recharge',
    next: 'guide.to.recharge',
    link: Page.rechargePage,
  },
  [GuideFrom[GUIDE_FROM_WITHDRAW_CURRENCY]]: {
    title: 'guide.for.withdraw',
    next: 'guide.to.withdraw',
    link: Page.withdrawPage,
  },
};

const typeContent = {
  [GuideType[GUIDE_KYC1]]: {
    text: 'guide.type.kyc1',
    link: Page.verification,
  },
  [GuideType[GUIDE_KYC2]]: {
    text: 'guide.type.kyc2',
    link: Page.verification,
  },
  [GuideType[GUIDE_EMAIL]]: {
    text: 'guide.type.email',
    link: Page.setEmail,
  },
  [GuideType[GUIDE_STEP2]]: {
    text: 'guide.type.step2',
    link: Cookie.get('locale') === 'zh_CN' ? Page.setPhone : Page.setGoogle,
  },
  [GuideType[GUIDE_TRADE_PWD]]: {
    text: 'guide.type.tradePwd',
    link: Page.setTradePassword,
  },
};

const GuideBox = inject('guideStore')(
  observer(
    class GuideBox extends RootContext {
      constructor(props) {
        super(props);

        this.state = {};
      }

      componentDidMount() {}

      closeDialog = () => {
        const { guideStore } = this.props;
        guideStore.closeGuide();
      };

      toNext = () => {
        const { guideStore } = this.props;
        const status = guideStore.guideStateList;
        const fromObj = fromContent[guideStore.guideFrom] || {};
        guideStore.closeGuide();
        if (status.willList.length === 0) {
          this.linkTo(fromObj.link, true);
          guideStore.cleanGuide();
        } else {
          this.linkTo(typeContent[status.willList[0].type].link, true);
        }
      };

      render() {
        const { guideStore } = this.props;
        const status = guideStore.guideStateList;
        const fromObj = fromContent[guideStore.guideFrom] || {};
        return (
          <DialogOneBtn
            openWhen={guideStore.hasGuide && guideStore.isShow}
            enterText={this.translate(
              status.willList.length === 0 ? fromObj.next : 'guide.to.next'
            )}
            onEnter={this.toNext}
            onClose={this.closeDialog}
          >
            <div className="guide-box">
              <div className="guide-title">{this.translate(fromObj.title)}</div>
              {status.finishList.map((item, index) => {
                const typeItem = typeContent[item.type];
                return (
                  <div className="item" key={`guide_${index}`}>
                    <Icon className="okds-arrow-chevron-right-centered-md" />
                    <div className="item-content">
                      <span className="guide-num finish" /> <br />
                      <span className="guide-text">
                        {this.translate(typeItem.text)}
                      </span>
                      <br />
                      <span className="guide-state">
                        {this.translate('guide.complete')}
                      </span>
                    </div>
                  </div>
                );
              })}
              {status.willList.map((item, index) => {
                const typeItem = typeContent[item.type];
                return (
                  <div className="item" key={`guide_will_${index}`}>
                    <Icon className="okds-arrow-chevron-right-centered-md" />
                    <div className="item-content">
                      <span className="guide-num" /> <br />
                      <span className="guide-text">
                        {this.translate(typeItem.text)}
                      </span>
                      <br />
                      <span className="guide-state" />
                    </div>
                  </div>
                );
              })}
            </div>
          </DialogOneBtn>
        );
      }
    }
  )
);

export { GuideBox, GuideType, GuideFrom };
